import { Instagram, Twitter, Linkedin, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 mt-20 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="block w-2.5 h-2.5 bg-neon-cyan rounded-full" />
              <span className="font-heading font-black text-lg tracking-tight">
                TECHSAVVY<span className="text-neon-orange">PRENEURS</span>
              </span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm">
              One brand. Seven ventures. Built on quiet, consistent work — for people serious about real income.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {[Instagram, Twitter, Linkedin, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-link-${i}`}
                  className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-neon-cyan hover:text-neon-cyan transition-all"
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4">// Ventures</div>
            <ul className="space-y-2 text-sm text-white/60">
              <li>Business Consulting</li>
              <li>Walmart Wholesaling</li>
              <li>Credit Repair</li>
              <li>Property & Land Flipping</li>
              <li>Digital Trading</li>
              <li>Personal Training</li>
              <li>Digital Marketing</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4">// Company</div>
            <ul className="space-y-2 text-sm text-white/60">
              <li><a href="#about" className="hover:text-neon-cyan transition-colors">About</a></li>
              <li><a href="#process" className="hover:text-neon-cyan transition-colors">Process</a></li>
              <li><a href="#proof" className="hover:text-neon-cyan transition-colors">Proof</a></li>
              <li><a href="#contact" className="hover:text-neon-cyan transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline mb-4">// Contact</div>
            <ul className="space-y-2 text-sm text-white/60 font-mono">
              <li className="break-all">hello@techsavvypreneurs.com</li>
              <li>USA · Remote</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-mono text-xs uppercase tracking-widest text-white/30">
            © {new Date().getFullYear()} Techsavvypreneurs — All systems operational.
          </div>
          <div className="font-mono text-xs uppercase tracking-widest text-white/30">
            Build. Scale. Compound.
          </div>
        </div>
      </div>

      {/* Massive type background */}
      <div className="pointer-events-none select-none mt-12 overflow-hidden">
        <div className="font-heading font-black text-[18vw] leading-none tracking-tighter text-white/[0.03] whitespace-nowrap text-center">
          TECHSAVVYPRENEURS
        </div>
      </div>
    </footer>
  );
}
